import axios from "axios";
import { API } from "./client";

export const createAnalysisSession = ()         => axios.post(`${API}/analysis/create`);
export const uploadAnalysisFile    = (formData) => axios.post(`${API}/analysis/upload`, formData);
export const sendAnalysisChat      = (data)     => axios.post(`${API}/analysis/chat`, data);
export const getAnalysisSession    = (id)       => axios.get(`${API}/analysis/${id}`);
export const getAnalysisChat       = (id)       => axios.get(`${API}/analysis/${id}/chat`);
export const renameAnalysisSession = (id, name) => axios.patch(`${API}/analysis/${id}/name`, { name });
export const exportAnalysisTable   = (rows, format, filename) =>
  axios.post(`${API}/analysis/export-table`, { rows, format, filename }, { responseType: "blob" });
